module.exports = __webpack_public_path__ + "static/9.2_ancient_america_andean-777ce72752a083c8e238661f79ed8dcf.pdf";